/**
 * @generated SignedSource<<5b9573791702755caa0b594b5e789206>>
 * @relayHash 4713f1182970b33f17d5b769e20b933a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 409e93ff2e04f08fded0e7d94a8a5514c3db5148f6459f540f1d1cdfadeb8ea7

import type { ConcreteRequest } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type PageTreeMacroRootLevelQuery$variables = {
  spaceKey: string;
};
export type PageTreeMacroRootLevelQuery$data = {
  readonly ptpage: {
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly id: string;
        readonly lastUpdatedDate: {
          readonly value: string;
        } | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly id: string;
    readonly lastUpdatedDate: {
      readonly value: string;
    } | null;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
};
export type PageTreeMacroRootLevelQuery = {
  response: PageTreeMacroRootLevelQuery$data;
  variables: PageTreeMacroRootLevelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "status"
},
v4 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "kind": "ScalarField",
  "name": "subType"
},
v7 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MILLIS"
  }
],
v8 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v9 = {
  "args": (v7/*: any*/),
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v10 = {
  "args": (v7/*: any*/),
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "lastUpdatedDate",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
},
v11 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v12 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ]
          },
          {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageTreeMacroRootLevelQuery",
    "selections": (v12/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageTreeMacroRootLevelQuery",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "4713f1182970b33f17d5b769e20b933a",
    "id": "409e93ff2e04f08fded0e7d94a8a5514c3db5148f6459f540f1d1cdfadeb8ea7",
    "metadata": {},
    "name": "PageTreeMacroRootLevelQuery",
    "operationKind": "query",
    "text": "query PageTreeMacroRootLevelQuery($spaceKey:String!){ptpage(spaceKey:$spaceKey){id,title,status,hasChildren,type,subType,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui},followingSiblings{nodes{id,title,status,hasChildren,type,subType,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage}}}}"
  }
};
})();

(node as any).hash = "aa699a91c79ad64021b680f9983cb88c";

export default node;
